import { createSvgIcon } from "@mui/material/utils";

const DirectivesIcon = createSvgIcon(
  <path d="M5.99998 17.1978L0.802734 12.0006L5.99998 6.80334L7.59724 8.40059L4.02223 12.0006L7.59724 15.6006L5.99998 17.1978ZM10.5397 20.4738L8.37674 19.7903L13.4602 3.52734L15.6232 4.21084L10.5397 20.4738ZM18 17.1978L16.4027 15.6006L19.9777 12.0006L16.4027 8.40059L18 6.80334L23.1972 12.0006L18 17.1978Z" />,
  "Directives"
);

export default DirectivesIcon;
